export const internationalLawConst = {
  path: "/single-programs/international-law",
  title: "ФАКУЛЬТЕТ ПРАВА — МЕЖДУНАРОДНОЕ ПРАВО",
  contentJSX: (
    <>
      <p>
        <strong>Диплом: </strong>бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения: </strong>очно или дистанционно
      </p>
      <p>
        <strong>Форма связи: </strong>Получить консультацию приемной комиссии
      </p>
      <h2>Международное право — регулирование глобальных процессов на правовом уровне</h2>
      <p>
        Международное право лежит в основе взаимодействия государств, организаций и компаний на мировой арене. Эта программа предназначена
        для тех, кто хочет разбираться в юридических аспектах дипломатии, международной торговли, прав человека и транснациональных споров.
      </p>
      <p>
        Студенты изучают нормы международных договоров, гуманитарное право, торговое право, защиту прав человека и юрисдикции международных
        судов.
      </p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Основы международного публичного и частного права</li>
        <li>Международные договоры и правовые механизмы их исполнения</li>
        <li>Право Европейского Союза</li>
        <li>Гуманитарное и правозащитное право</li>
        <li>Международное торговое и инвестиционное право</li>
        <li>Арбитраж и разрешение международных споров</li>
        <li>Дипломатическое и консульское право</li>
        <li>Судебная практика международных судов (ЕС, ООН, ЕСПЧ)</li>
      </ul>
      <p>
        Обучение включает симуляции переговоров, разбор кейсов, участие в международных конференциях и доступ к правовым базам данных ЕС и
        ООН.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Международный юрист в корпорациях и юридических фирмах</li>
        <li>Дипломат или сотрудник международных организаций</li>
        <li>Консультант по праву ЕС или ВТО</li>
        <li>Юрист по правам человека</li>
        <li>Арбитражный специалист в международных трибуналах</li>
      </ul>
      <h2>Средний доход в Европе:</h2>
      <p>
        от <strong>€60,000 до €110,000 в год</strong> — особенно в структуре ЕС, международных судах и крупных транснациональных компаниях.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом, признанный в международной среде</li>
        <li>Возможность обучения на русском или английском языке</li>
        <li>Гибкий формат: очно или дистанционно</li>
        <li>Доступ к международным правовым системам</li>
        <li>Стажировки в юридических департаментах и международных организациях</li>
        <li>Академическая и карьерная поддержка</li>
      </ul>
      <p>Международное право — профессия, которая формирует законы глобального мира.</p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия поможет вам с выбором программы, подготовкой документов и подачей заявки.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии
    Международное право — регулирование глобальных процессов на правовом уровне
    Международное право лежит в основе взаимодействия государств, организаций и компаний на мировой арене. Эта программа предназначена для тех, кто хочет разбираться в юридических аспектах дипломатии, международной торговли, прав человека и транснациональных споров.
    Студенты изучают нормы международных договоров, гуманитарное право, торговое право, защиту прав человека и юрисдикции международных судов.
    Что вы будете изучать?
    • Основы международного публичного и частного права
    • Международные договоры и правовые механизмы их исполнения
    • Право Европейского Союза
    • Гуманитарное и правозащитное право
    • Международное торговое и инвестиционное право
    • Арбитраж и разрешение международных споров
    • Дипломатическое и консульское право
    • Судебная практика международных судов (ЕС, ООН, ЕСПЧ)
    Обучение включает симуляции переговоров, разбор кейсов, участие в международных конференциях и доступ к правовым базам данных ЕС и ООН.
    Кем можно работать после окончания?
    • Международный юрист в корпорациях и юридических фирмах
    • Дипломат или сотрудник международных организаций
    • Консультант по праву ЕС или ВТО
    • Юрист по правам человека
    • Арбитражный специалист в международных трибуналах
    Зарплата в Европе: от €60,000 до €110,000 в год — особенно в структуре ЕС, международных судах и крупных транснациональных компаниях.
    Почему выбирают нас?
    • Европейский диплом, признанный в международной среде
    • Возможность обучения на русском или английском языке
    • Гибкий формат: очно или дистанционно
    • Доступ к международным правовым системам
    • Стажировки в юридических департаментах и международных организациях
    • Академическая и карьерная поддержка
    Международное право — профессия, которая формирует законы глобального мира.
    Как поступить? 
    Приёмная комиссия поможет вам с выбором программы, подготовкой документов и подачей заявки.
  `,
};
